<template>
  <div>
    <report-management v-bind="$props" />
  </div>
</template>
<script>
import ReportManagement from "./Report/report.vue";
export default {
  name: "report-wrapper",
  props: {
    report_id: {
      type: [String, Number],
      required: true,
    },
    JString: {
      type: Object,
      required: true
    }
  },
  components: {
    ReportManagement,
  }
};
</script>